"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressToAssetSymbol = exports.VAULTS_MAP = exports.SWAPLINE_MAP = exports.sleep = exports.toEffectiveFee = exports.calculateUserMaxDebt = exports.calculateUserCollateral = exports.calculateDebt = exports.calculateLiquidation = exports.divUp = exports.fromPercentToInterestRate = exports.toScale = exports.toDecimal = exports.decimalToPercent = exports.percentToDecimal = exports.tou64 = exports.signAndSend = exports.ERRORS_EXCHANGE = exports.ERRORS = exports.INTEREST_RATE_DECIMALS = exports.XUSD_DECIMALS = exports.SNY_DECIMALS = exports.UNIFIED_PERCENT_SCALE = exports.ACCURACY = exports.ORACLE_OFFSET = exports.DEFAULT_PUBLIC_KEY = void 0;
const anchor_1 = require("@project-serum/anchor");
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const network_1 = require("./network");
exports.DEFAULT_PUBLIC_KEY = new web3_js_1.PublicKey(0);
exports.ORACLE_OFFSET = 8;
exports.ACCURACY = 6; // TODO: remove, use always XUSD_DECIMALS
exports.UNIFIED_PERCENT_SCALE = 5;
exports.SNY_DECIMALS = 6;
exports.XUSD_DECIMALS = 6;
exports.INTEREST_RATE_DECIMALS = 18;
// hex code must be at the end of message
var ERRORS;
(function (ERRORS) {
    ERRORS["SIGNATURE"] = "Error: Signature verification failed";
    ERRORS["SIGNER"] = "Error: unknown signer";
    ERRORS["PANICKED"] = "Program failed to complete";
    ERRORS["SERIALIZATION"] = "0xa4";
    ERRORS["ALLOWANCE"] = "custom program error: 0x1";
    ERRORS["NO_SIGNERS"] = "Error: No signers";
})(ERRORS = exports.ERRORS || (exports.ERRORS = {}));
var ERRORS_EXCHANGE;
(function (ERRORS_EXCHANGE) {
    ERRORS_EXCHANGE["UNAUTHORIZED"] = "0x12c";
    ERRORS_EXCHANGE["NOT_SYNTHETIC_USD"] = "0x12d";
    ERRORS_EXCHANGE["OUTDATED_ORACLE"] = "0x12e";
    ERRORS_EXCHANGE["MINT_LIMIT"] = "0x12f";
    ERRORS_EXCHANGE["WITHDRAW_LIMIT"] = "0x130";
    ERRORS_EXCHANGE["COLLATERAL_ACCOUNT_ERROR"] = "0x131";
    ERRORS_EXCHANGE["SYNTHETIC_COLLATERAL"] = "0x132";
    ERRORS_EXCHANGE["INVALID_ASSETS_LIST"] = "0x133";
    ERRORS_EXCHANGE["INVALID_LIQUIDATION"] = "0x134";
    ERRORS_EXCHANGE["INVALID_SIGNER"] = "0x135";
    ERRORS_EXCHANGE["WASH_TRADE"] = "0x136";
    ERRORS_EXCHANGE["EXCHANGE_LIQUIDATION_ACCOUNT"] = "0x137";
    ERRORS_EXCHANGE["LIQUIDATION_DEADLINE"] = "0x138";
    ERRORS_EXCHANGE["HALTED"] = "0x139";
    ERRORS_EXCHANGE["NO_REWARDS"] = "0x13a";
    ERRORS_EXCHANGE["FUND_ACCOUNT_ERROR"] = "0x13b";
    ERRORS_EXCHANGE["SWAP_UNAVAILABLE"] = "0x13c";
    ERRORS_EXCHANGE["INITIALIZED"] = "0x13d";
    ERRORS_EXCHANGE["UNINITIALIZED"] = "0x13e";
    ERRORS_EXCHANGE["NO_ASSET_FOUND"] = "0x13f";
    ERRORS_EXCHANGE["MAX_SUPPLY"] = "0x140";
    ERRORS_EXCHANGE["NOT_COLLATERAL"] = "0x141";
    ERRORS_EXCHANGE["ALREADY_COLLATERAL"] = "0x142";
    ERRORS_EXCHANGE["INSUFFICIENT_VALUE_TRADE"] = "0x143";
    ERRORS_EXCHANGE["INSUFFICIENT_AMOUNT_ADMIN_WITHDRAW"] = "0x144";
    ERRORS_EXCHANGE["SETTLEMENT_NOT_REACHED"] = "0x145";
    ERRORS_EXCHANGE["USD_SETTLEMENT"] = "0x146";
    ERRORS_EXCHANGE["PARAMETER_OUT_OF_RANGE"] = "0x147";
    ERRORS_EXCHANGE["OVERFLOW"] = "0x148";
    ERRORS_EXCHANGE["DIFFERENT_SCALE"] = "0x149";
    ERRORS_EXCHANGE["MISMATCHED_TOKENS"] = "0x14a";
    ERRORS_EXCHANGE["SWAPLINE_LIMIT"] = "0x14b";
    ERRORS_EXCHANGE["COLLATERAL_LIMIT_EXCEEDED"] = "0x14c";
    ERRORS_EXCHANGE["USER_BORROW_LIMIT"] = "0x14d";
    ERRORS_EXCHANGE["VAULT_BORROW_LIMIT"] = "0x14e";
    ERRORS_EXCHANGE["VAULT_WITHDRAW_LIMIT"] = "0x14f";
    ERRORS_EXCHANGE["INVALID_ACCOUNT"] = "0x150";
    ERRORS_EXCHANGE["PRICE_CONFIDENCE_OUT_OF_RANGE"] = "0x151";
    ERRORS_EXCHANGE["INVALID_ORACLE_PROGRAM"] = "0x152";
})(ERRORS_EXCHANGE = exports.ERRORS_EXCHANGE || (exports.ERRORS_EXCHANGE = {}));
const signAndSend = (tx, signers, connection, opts) => __awaiter(void 0, void 0, void 0, function* () {
    tx.setSigners(...signers.map((s) => s.publicKey));
    const blockhash = yield connection.getRecentBlockhash((opts === null || opts === void 0 ? void 0 : opts.commitment) || anchor_1.Provider.defaultOptions().commitment);
    tx.recentBlockhash = blockhash.blockhash;
    tx.partialSign(...signers);
    const rawTx = tx.serialize();
    return yield (0, web3_js_1.sendAndConfirmRawTransaction)(connection, rawTx, opts || anchor_1.Provider.defaultOptions());
});
exports.signAndSend = signAndSend;
const tou64 = (amount) => {
    // eslint-disable-next-line new-cap
    return new spl_token_1.u64(amount.toString());
};
exports.tou64 = tou64;
const percentToDecimal = (value) => {
    return { val: new anchor_1.BN(value * Math.pow(10, (exports.UNIFIED_PERCENT_SCALE - 2))), scale: exports.UNIFIED_PERCENT_SCALE };
};
exports.percentToDecimal = percentToDecimal;
const decimalToPercent = (decimal) => {
    return decimal.val.toNumber() / Math.pow(10, (decimal.scale - 2));
};
exports.decimalToPercent = decimalToPercent;
const toDecimal = (value, scale) => {
    return { val: value, scale: scale };
};
exports.toDecimal = toDecimal;
const toScale = (decimal, scale) => {
    if (decimal.scale > scale) {
        return {
            val: decimal.val.div(new anchor_1.BN(10).pow(new anchor_1.BN(decimal.scale - scale))),
            scale
        };
    }
    else {
        return {
            val: decimal.val.mul(new anchor_1.BN(10).pow(new anchor_1.BN(scale - decimal.scale))),
            scale
        };
    }
};
exports.toScale = toScale;
const fromPercentToInterestRate = (percent) => {
    return (0, exports.toScale)((0, exports.percentToDecimal)(percent), exports.INTEREST_RATE_DECIMALS);
};
exports.fromPercentToInterestRate = fromPercentToInterestRate;
const divUp = (a, b) => {
    return a.add(b.subn(1)).div(b);
};
exports.divUp = divUp;
const calculateLiquidation = (maxDebt, debtValue, penaltyToLiquidator, penaltyToExchange, liquidationRate, asset, collateral) => {
    if (maxDebt.gt(debtValue)) {
        throw new Error('Account is safe');
    }
    let maxAmount;
    if (debtValue.lte(new anchor_1.BN(1 * Math.pow(10, exports.XUSD_DECIMALS)))) {
        maxAmount = debtValue;
    }
    else {
        maxAmount = debtValue.mul(liquidationRate.val).divn(Math.pow(10, liquidationRate.scale));
    }
    const seizedCollateralInUsd = (0, exports.divUp)(maxAmount.mul(penaltyToExchange.val.add(penaltyToLiquidator.val)), new anchor_1.BN(Math.pow(10, penaltyToExchange.scale))).add(maxAmount);
    const seizedInToken = seizedCollateralInUsd
        .mul(new anchor_1.BN(10).pow(new anchor_1.BN(collateral.reserveBalance.scale + exports.ORACLE_OFFSET - exports.ACCURACY)))
        .div(asset.price.val);
    const collateralToExchange = (0, exports.divUp)(seizedInToken.mul(penaltyToExchange.val), new anchor_1.BN(Math.pow(10, penaltyToExchange.scale)).add(penaltyToExchange.val).add(penaltyToLiquidator.val));
    const collateralToLiquidator = seizedInToken.sub(collateralToExchange);
    return { seizedInToken, maxAmount, collateralToExchange, collateralToLiquidator };
};
exports.calculateLiquidation = calculateLiquidation;
const calculateDebt = (assetsList) => {
    return assetsList.synthetics.reduce((acc, synthetic) => acc.add(synthetic.supply.val
        .sub(synthetic.swaplineSupply.val)
        .sub(synthetic.borrowedSupply.val)
        .mul(assetsList.assets[synthetic.assetIndex].price.val)
        .div(new anchor_1.BN(Math.pow(10, (synthetic.supply.scale + exports.ORACLE_OFFSET - exports.ACCURACY))))), new anchor_1.BN(0));
};
exports.calculateDebt = calculateDebt;
const calculateUserCollateral = (exchangeAccount, assetsList) => {
    return exchangeAccount.collaterals.reduce((acc, entry) => {
        const collateral = assetsList.collaterals[entry.index];
        return acc.add(entry.amount
            .mul(assetsList.assets[collateral.assetIndex].price.val)
            .div(new anchor_1.BN(Math.pow(10, (collateral.reserveBalance.scale + exports.ORACLE_OFFSET - exports.ACCURACY)))));
    }, new anchor_1.BN(0));
};
exports.calculateUserCollateral = calculateUserCollateral;
const calculateUserMaxDebt = (exchangeAccount, assetsList) => {
    return exchangeAccount.collaterals.reduce((acc, entry) => {
        const collateral = assetsList.collaterals[entry.index];
        const asset = assetsList.assets[collateral.assetIndex];
        return acc.add(entry.amount
            .mul(asset.price.val)
            .mul(collateral.collateralRatio.val)
            .divn(Math.pow(10, collateral.collateralRatio.scale))
            .div(new anchor_1.BN(Math.pow(10, (collateral.reserveBalance.scale + exports.ORACLE_OFFSET - exports.ACCURACY)))));
    }, new anchor_1.BN(0));
};
exports.calculateUserMaxDebt = calculateUserMaxDebt;
const toEffectiveFee = (fee, userCollateralBalance) => {
    // decimals of token = 6
    const ONE_SNY = new anchor_1.BN(1000000);
    let discount = 0;
    switch (true) {
        case userCollateralBalance.lt(ONE_SNY.muln(100)):
            discount = 0;
            break;
        case userCollateralBalance.lt(ONE_SNY.muln(200)):
            discount = 1;
            break;
        case userCollateralBalance.lt(ONE_SNY.muln(500)):
            discount = 2;
            break;
        case userCollateralBalance.lt(ONE_SNY.muln(1000)):
            discount = 3;
            break;
        case userCollateralBalance.lt(ONE_SNY.muln(2000)):
            discount = 4;
            break;
        case userCollateralBalance.lt(ONE_SNY.muln(5000)):
            discount = 5;
            break;
        case userCollateralBalance.lt(ONE_SNY.muln(10000)):
            discount = 6;
            break;
        case userCollateralBalance.lt(ONE_SNY.muln(25000)):
            discount = 7;
            break;
        case userCollateralBalance.lt(ONE_SNY.muln(50000)):
            discount = 8;
            break;
        case userCollateralBalance.lt(ONE_SNY.muln(100000)):
            discount = 9;
            break;
        case userCollateralBalance.lt(ONE_SNY.muln(250000)):
            discount = 10;
            break;
        case userCollateralBalance.lt(ONE_SNY.muln(500000)):
            discount = 11;
            break;
        case userCollateralBalance.lt(ONE_SNY.muln(1000000)):
            discount = 12;
            break;
        case userCollateralBalance.lt(ONE_SNY.muln(2000000)):
            discount = 13;
            break;
        case userCollateralBalance.lt(ONE_SNY.muln(5000000)):
            discount = 14;
            break;
        case userCollateralBalance.lt(ONE_SNY.muln(10000000)):
            discount = 15;
            break;
    }
    return (0, exports.toDecimal)(fee.val.sub(fee.val.muln(discount).divn(100)), fee.scale);
};
exports.toEffectiveFee = toEffectiveFee;
const sleep = (ms) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve) => setTimeout(resolve, ms));
});
exports.sleep = sleep;
exports.SWAPLINE_MAP = {
    [network_1.Network.DEV]: [
        {
            synthetic: new web3_js_1.PublicKey('76qqFEokX3VgTxXX8dZYkDMijFtoYbJcxZZU4DgrDnUF'),
            collateral: new web3_js_1.PublicKey('HgexCyLCZUydm7YcJWeZRMK9HzsU17NJQvJGnMuzGVKG')
        },
        {
            synthetic: new web3_js_1.PublicKey('3zPcvFVBuV4f8hnwpWAsextaqFs73jB6JWvmYq5K7X2w'),
            collateral: new web3_js_1.PublicKey('So11111111111111111111111111111111111111112')
        },
        {
            synthetic: new web3_js_1.PublicKey('6QARYJsmN7EfnUFPn8X1qFANhT2CssLU6DyTtCkE3JNX'),
            collateral: new web3_js_1.PublicKey('CzxkxsqcijCGLtP4jhCrjVofvjyyciRbe5XFJTEXG7Sj')
        }
    ],
    [network_1.Network.LOCAL]: [],
    [network_1.Network.MAIN]: [
        // USDC<>xUSD
        {
            synthetic: new web3_js_1.PublicKey('83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y'),
            collateral: new web3_js_1.PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v')
        },
        // WSOL<>xSOL
        {
            synthetic: new web3_js_1.PublicKey('BdUJucPJyjkHxLMv6ipKNUhSeY3DWrVtgxAES1iSBAov'),
            collateral: new web3_js_1.PublicKey('So11111111111111111111111111111111111111112')
        },
        // renBTC<>xBTC
        {
            synthetic: new web3_js_1.PublicKey('HWxpSV3QAGzLQzGAtvhSYAEr7sTQugQygnni1gnUGh1D'),
            collateral: new web3_js_1.PublicKey('CDJWUqTcYTVAKXAVXoQZFes5JUFc7owSeq7eMQcDSbo5')
        },
        // whETH<>xETH
        {
            synthetic: new web3_js_1.PublicKey('8bqjz8DeSuim1sEAsQatjJN4zseyxSPdhHQcuuhL8PCK'),
            collateral: new web3_js_1.PublicKey('7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs')
        },
        // whFTT<>xFTT
        {
            synthetic: new web3_js_1.PublicKey('Fr3W7NPVvdVbwMcHgA7Gx2wUxP43txdsn3iULJGFbKz9'),
            collateral: new web3_js_1.PublicKey('EzfgjvkSwthhgHaceR3LnKXUoRkP6NUhfghdaHAj1tUv')
        }
    ],
    [network_1.Network.TEST]: []
};
exports.VAULTS_MAP = {
    [network_1.Network.DEV]: [
        {
            synthetic: new web3_js_1.PublicKey('HL5aKrMbm13a6VGNRSxJmy61nRsgySDacHVpLzCwHhL5'),
            collateral: new web3_js_1.PublicKey('76qqFEokX3VgTxXX8dZYkDMijFtoYbJcxZZU4DgrDnUF'),
            vaultType: 0
        },
        {
            synthetic: new web3_js_1.PublicKey('3zPcvFVBuV4f8hnwpWAsextaqFs73jB6JWvmYq5K7X2w'),
            collateral: new web3_js_1.PublicKey('91qzpKj8nwYkssvG52moAtUUiWV5w4CuHwhkPQtBWTDE'),
            vaultType: 0
        },
        {
            synthetic: new web3_js_1.PublicKey('3zPcvFVBuV4f8hnwpWAsextaqFs73jB6JWvmYq5K7X2w'),
            collateral: new web3_js_1.PublicKey('91qzpKj8nwYkssvG52moAtUUiWV5w4CuHwhkPQtBWTDE'),
            vaultType: 1
        },
        {
            synthetic: new web3_js_1.PublicKey('BPyw7qZrDTiUdUTCUSMcuyZnYEf4P2yo92L15L3VoK7V'),
            collateral: new web3_js_1.PublicKey('HgexCyLCZUydm7YcJWeZRMK9HzsU17NJQvJGnMuzGVKG'),
            vaultType: 1
        }
    ],
    [network_1.Network.LOCAL]: [],
    [network_1.Network.MAIN]: [
        {
            synthetic: new web3_js_1.PublicKey('BdUJucPJyjkHxLMv6ipKNUhSeY3DWrVtgxAES1iSBAov'),
            collateral: new web3_js_1.PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
            vaultType: 0
        },
        {
            synthetic: new web3_js_1.PublicKey('83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y'),
            collateral: new web3_js_1.PublicKey('BdUJucPJyjkHxLMv6ipKNUhSeY3DWrVtgxAES1iSBAov'),
            vaultType: 0
        },
        {
            synthetic: new web3_js_1.PublicKey('83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y'),
            collateral: new web3_js_1.PublicKey('mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'),
            vaultType: 0
        },
        {
            synthetic: new web3_js_1.PublicKey('83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y'),
            collateral: new web3_js_1.PublicKey('BdUJucPJyjkHxLMv6ipKNUhSeY3DWrVtgxAES1iSBAov'),
            vaultType: 3
        },
        {
            synthetic: new web3_js_1.PublicKey('83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y'),
            collateral: new web3_js_1.PublicKey('Fr3W7NPVvdVbwMcHgA7Gx2wUxP43txdsn3iULJGFbKz9'),
            vaultType: 3
        },
        {
            synthetic: new web3_js_1.PublicKey('83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y'),
            collateral: new web3_js_1.PublicKey('8bqjz8DeSuim1sEAsQatjJN4zseyxSPdhHQcuuhL8PCK'),
            vaultType: 3
        },
        {
            synthetic: new web3_js_1.PublicKey('83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y'),
            collateral: new web3_js_1.PublicKey('6MeoZEcUMhAB788YXTQN4x7K8MnwSt6RHWsLkuq9GJb2'),
            vaultType: 3
        },
        {
            synthetic: new web3_js_1.PublicKey('83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y'),
            collateral: new web3_js_1.PublicKey('82Afat35Wr9v4fsZfSqGh8dnXFjxeaiQBfm5G9TK1BNj'),
            vaultType: 3
        },
        {
            synthetic: new web3_js_1.PublicKey('83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y'),
            collateral: new web3_js_1.PublicKey('HtxznfExBatdX28kMFDvmvU1rXVwiG3JSWcNPdFQ4PLh'),
            vaultType: 3
        },
        {
            synthetic: new web3_js_1.PublicKey('83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y'),
            collateral: new web3_js_1.PublicKey('HWxpSV3QAGzLQzGAtvhSYAEr7sTQugQygnni1gnUGh1D'),
            vaultType: 3
        },
        {
            synthetic: new web3_js_1.PublicKey('HWxpSV3QAGzLQzGAtvhSYAEr7sTQugQygnni1gnUGh1D'),
            collateral: new web3_js_1.PublicKey('83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y'),
            vaultType: 3
        },
        {
            synthetic: new web3_js_1.PublicKey('BdUJucPJyjkHxLMv6ipKNUhSeY3DWrVtgxAES1iSBAov'),
            collateral: new web3_js_1.PublicKey('83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y'),
            vaultType: 3
        },
        {
            synthetic: new web3_js_1.PublicKey('Fr3W7NPVvdVbwMcHgA7Gx2wUxP43txdsn3iULJGFbKz9'),
            collateral: new web3_js_1.PublicKey('83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y'),
            vaultType: 3
        },
        {
            synthetic: new web3_js_1.PublicKey('8bqjz8DeSuim1sEAsQatjJN4zseyxSPdhHQcuuhL8PCK'),
            collateral: new web3_js_1.PublicKey('83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y'),
            vaultType: 3
        },
        {
            synthetic: new web3_js_1.PublicKey('6MeoZEcUMhAB788YXTQN4x7K8MnwSt6RHWsLkuq9GJb2'),
            collateral: new web3_js_1.PublicKey('83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y'),
            vaultType: 3
        },
        {
            synthetic: new web3_js_1.PublicKey('82Afat35Wr9v4fsZfSqGh8dnXFjxeaiQBfm5G9TK1BNj'),
            collateral: new web3_js_1.PublicKey('83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y'),
            vaultType: 3
        },
        {
            synthetic: new web3_js_1.PublicKey('HtxznfExBatdX28kMFDvmvU1rXVwiG3JSWcNPdFQ4PLh'),
            collateral: new web3_js_1.PublicKey('83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y'),
            vaultType: 3
        }
    ],
    [network_1.Network.TEST]: []
};
exports.addressToAssetSymbol = {
    //Local
    '8V8JuSxR4SCSbqp2f74w7Kiv93FBbqfmPQGSJ1x2MPYi': 'xUSD',
    qB6GZSkKLWkkPEzraDdroAVvMFWyvvw9PWP71PKfAsm: 'SNY',
    '5Hm3K6nNUJ8gBQTQhLBb8ZHC8BupaED6mkws3vXPuHyH': 'xBTC',
    HPxzYx1doGTbwJx6AJmtsx1iN53v6sV2nPy7VgeA5aJ7: 'xSOL',
    '2HnwLrUhdkUg7zLmC2vaU9gVppkLo9WMPHyJK49h9SRa': 'xSRM',
    //Dev
    '76qqFEokX3VgTxXX8dZYkDMijFtoYbJcxZZU4DgrDnUF': 'xUSD',
    '91qzpKj8nwYkssvG52moAtUUiWV5w4CuHwhkPQtBWTDE': 'SNY',
    HL5aKrMbm13a6VGNRSxJmy61nRsgySDacHVpLzCwHhL5: 'xBTC',
    '3zPcvFVBuV4f8hnwpWAsextaqFs73jB6JWvmYq5K7X2w': 'xSOL',
    BPyw7qZrDTiUdUTCUSMcuyZnYEf4P2yo92L15L3VoK7V: 'xFTT',
    '6QARYJsmN7EfnUFPn8X1qFANhT2CssLU6DyTtCkE3JNX': 'xETH',
    CzxkxsqcijCGLtP4jhCrjVofvjyyciRbe5XFJTEXG7Sj: 'whETH',
    So11111111111111111111111111111111111111112: 'WSOL',
    oBNJxzeq1bkmSyULuqQoQtyHQMh8st8yfm4e7WqoJky: 'stSOL',
    HgexCyLCZUydm7YcJWeZRMK9HzsU17NJQvJGnMuzGVKG: 'USDC',
    //Testnet
    '2XyMRw6MHMFVu1VBLGYKJa8GSjM5h7AvNkynu2wPpnfH': 'xUSD',
    Cf21AhB2VnwNTJk7Wf6jRHEyjXriVyprEHVp6bQzzVXX: 'SNY',
    '3Zn5ewamQsEQVv8i1vKzCHP9rpnJdH5bU3iPUQwMmoXM': 'xBTC',
    '9WNjiufPPCZDHLhkNKW6CLzqgy3Sp8yb4eQ5XaCmurXU': 'xSOL',
    '5wqex5HHs2rEkXfHgiD6VYmT5TvrK1LJscZQDkZLdi4R': 'xSRM',
    DFQXctKS9mYkU7TmcjjxP8avzqSj3euXkpiFabPuMjUo: 'xFTT',
    Auaz6F4BPLchbR42LksZxZXQnTbeShVNDp777Q2BWxP4: 'xETH',
    //Mainnet
    '83LGLCm7QKpYZbX8q4W2kYWbtt8NJBwbVwEepzkVnJ9y': 'xUSD',
    '4dmKkXNHdgYsXqBHCuMikNQWwVomZURhYvkkX5c4pQ7y': 'SNY',
    HWxpSV3QAGzLQzGAtvhSYAEr7sTQugQygnni1gnUGh1D: 'xBTC',
    BdUJucPJyjkHxLMv6ipKNUhSeY3DWrVtgxAES1iSBAov: 'xSOL',
    Fr3W7NPVvdVbwMcHgA7Gx2wUxP43txdsn3iULJGFbKz9: 'xFTT',
    '8bqjz8DeSuim1sEAsQatjJN4zseyxSPdhHQcuuhL8PCK': 'xETH',
    '6MeoZEcUMhAB788YXTQN4x7K8MnwSt6RHWsLkuq9GJb2': 'xLUNA',
    EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v: 'USDC',
    CDJWUqTcYTVAKXAVXoQZFes5JUFc7owSeq7eMQcDSbo5: 'renBTC',
    EzfgjvkSwthhgHaceR3LnKXUoRkP6NUhfghdaHAj1tUv: 'whFTT',
    '7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs': 'whETH',
    mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So: 'mSOL',
    '82Afat35Wr9v4fsZfSqGh8dnXFjxeaiQBfm5G9TK1BNj': 'xDOT',
    HtxznfExBatdX28kMFDvmvU1rXVwiG3JSWcNPdFQ4PLh: 'xAVAX',
    '7TEcMnoVJtZgpWCdnLu8X15bTtnt4J2zZyBxfV7i2uw7': 'xDOGE',
    HavRcoAaHq7SwLK7qB14TRkJ3eq9QQW1cdYLwHZKaNci: 'xGOLD',
    FXe7K4EtThAzsu7dphLBKtbjFwE3AeMaFC7kwVd3ifhS: 'xC98',
    '7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj': 'stSOL'
};
